import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import { EventsCard } from "../Cards/EventsCard";
import { InfoBar } from "../InfoBar";
import { Loading } from "../../shared-components/Loading/Loading";
import { NotFound } from "../../shared-components/NotFound";
import { Pagination } from "../../../react-components/events-components/Pagination";
import EventsSearchContext from "../../../../application/Context/EventsSearchContext";
import { motion } from "framer-motion";
export var Events = function () {
    var _a = useContext(EventsSearchContext), events = _a.events, eventsIsLoading = _a.eventsIsLoading, count = _a.count;
    return eventsIsLoading ? (_jsx(Loading, {})) : events.length > 0 ? (_jsxs(React.Fragment, { children: [_jsxs(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 }, exit: { opacity: 0 }, children: [_jsx(InfoBar, { elements: count }), events.map(function (event, i) {
                        return (_jsx(EventsCard, { item: event }, i));
                    })] }), _jsx(Pagination, {})] })) : (_jsxs(React.Fragment, { children: [_jsx(InfoBar, { elements: count }), _jsx(NotFound, {})] }));
};
